"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaResultReferReducer = exports.kansaResultReferActions = exports.TYPES = exports.INIT_STATE = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const REFER = 'kansaResultRefter';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_ENTRY: REFER + 'SetEntry',
  CHANGE_BUNRUICD: REFER + 'ChangeBunruiCd',
  CHANGE_HAKKENJIKO: REFER + 'ChangeHakkenjiko',
  SET_ENTRIES: REFER + 'SetEntries',
  SET_KANSATGTJIGYOBASICINFO: REFER + 'SetkansaTgtJigyoBasicInfo',
  SET_FOLLOWUPLIST: REFER + 'SetFollowupList',
  SET_GOODPOINTLIST: REFER + 'SetGoodpointList',
  SET_KAIZENLIST: REFER + 'SetKaizenList',
  SET_FUTEKIGOLIST: REFER + 'SetFutekigoList',
  SET_SEIJUKUDO: REFER + 'SetSeijukudo',
  SET_USER_INFO: REFER + 'SetUserInfo',
  SET_KANSA_INFO: REFER + 'SetKansaInfo',
  SET_CONTENT: REFER + 'SetContent',
  SET_RETURN_BTN: REFER + 'SetReturnBtn',
  SET_REGISTER_DT: REFER + 'SetRegisterDt',
  CLEAR: REFER + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  REFER: 'refer'
};

/**
 * 初期State
 */
const INIT_STATE = exports.INIT_STATE = {
  dispContent: CONTENTS.REFER,
  registerDt: '',
  userInfo: {
    shainNm: '',
    kaishaNm: '',
    soshikiNm: ''
  },
  kansaInfo: {
    kansaTgtNendo: '',
    kansaTgtJigyoId: ''
  },
  entries: {
    shoninDate: '',
    shoninshaNm: '',
    sogohyoka: '',
    naibukansaJissiDt: '',
    naibukansaJissiPlace: '',
    sokatsu: '',
    kansabumonComment: '',
    followupList: ''
  },
  listState: [],
  kansaTgtJigyoBasicInfo: '',
  followupList: '',
  goodpointList: '',
  kaizenList: '',
  futekigoList: '',
  seijukudo: '',
  returnBtn: ''
};

/**
 * アクション定義
 */
const kansaResultReferActions = exports.kansaResultReferActions = (0, _reduxActions.createActions)({
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_BUNRUICD]: function () {
    return {
      userId: arguments.length <= 0 ? undefined : arguments[0],
      hakkenjikoBunruiCd: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_HAKKENJIKO]: function () {
    return {
      userId: arguments.length <= 0 ? undefined : arguments[0],
      hakkenjiko: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KANSATGTJIGYOBASICINFO]: function () {
    return {
      kansaTgtJigyoBasicInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_FOLLOWUPLIST]: function () {
    return {
      followupList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_GOODPOINTLIST]: function () {
    return {
      goodpointList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KAIZENLIST]: function () {
    return {
      kaizenList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_FUTEKIGOLIST]: function () {
    return {
      futekigoList: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SEIJUKUDO]: function () {
    return {
      seijukudo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_USER_INFO]: function () {
    return {
      userInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KANSA_INFO]: function () {
    return {
      kansaInfo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_RETURN_BTN]: function () {
    return {
      btn: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_REGISTER_DT]: function () {
    return {
      dt: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.CLEAR);

/**
 * Reducer定義
 */
const kansaResultReferReducer = exports.kansaResultReferReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.CHANGE_BUNRUICD]: (state, action) => {
    let newListState = Object.assign({}, state.listState);
    const {
      hakkenjikoBunruiCdOrg
    } = newListState[action.payload.userId];
    newListState[action.payload.userId] = _objectSpread(_objectSpread({}, newListState[action.payload.userId]), {}, {
      isChange: action.payload.hakkenjikoBunruiCd !== hakkenjikoBunruiCdOrg && !(action.payload.hakkenjikoBunruiCd === _CodeConsts.CODE.KANSA_HKN_BNR.KBN && hakkenjikoBunruiCdOrg === null),
      hakkenjikoBunruiCd: action.payload.hakkenjikoBunruiCd,
      hakkenjikoBunruiCdOrg: hakkenjikoBunruiCdOrg
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listState: newListState
    });
  },
  [TYPES.CHANGE_HAKKENJIKO]: (state, action) => {
    let newListState = Object.assign({}, state.listState);
    const {
      hakkenjikoOrg
    } = newListState[action.payload.userId];
    newListState[action.payload.userId] = _objectSpread(_objectSpread({}, newListState[action.payload.userId]), {}, {
      isChange: action.payload.hakkenjiko !== hakkenjikoOrg && !(hakkenjikoOrg === null),
      hakkenjiko: action.payload.hakkenjiko,
      hakkenjikoOrg: hakkenjikoOrg
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      listState: newListState
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: action.payload.entries
    });
  },
  [TYPES.SET_KANSATGTJIGYOBASICINFO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaTgtJigyoBasicInfo: action.payload.kansaTgtJigyoBasicInfo
    });
  },
  [TYPES.SET_FOLLOWUPLIST]: (state, action) => {
    let newListState = {};
    action.payload.followupList.forEach(data => {
      newListState[data.kansaTgtNendo + data.kansaTgtJigyoId + data.shitekijikoKbnCd + data.no] = {
        isChange: false,
        kansaTgtNendo: data.kansaTgtNendo,
        kansaTgtJigyoId: data.kansaTgtJigyoId,
        shitekijikoKbnCd: data.shitekijikoKbnCd,
        no: data.no,
        hakkenjikoBunruiCd: data.hakkenjikoBunruiCd,
        hakkenjiko: data.hakkenjiko,
        exclusion: data.exclusion ? true : false,
        exclusionOrg: data.exclusion ? true : false,
        insert: data.exclusion === null ? true : false
      };
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      followupList: action.payload.followupList,
      listState: newListState
    });
  },
  [TYPES.SET_GOODPOINTLIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      goodpointList: action.payload.goodpointList
    });
  },
  [TYPES.SET_KAIZENLIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kaizenList: action.payload.kaizenList
    });
  },
  [TYPES.SET_FUTEKIGOLIST]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      futekigoList: action.payload.futekigoList
    });
  },
  [TYPES.SET_SEIJUKUDO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      seijukudo: action.payload.seijukudo
    });
  },
  [TYPES.SET_USER_INFO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      userInfo: action.payload.userInfo
    });
  },
  [TYPES.SET_KANSA_INFO]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kansaInfo: action.payload.kansaInfo
    });
  },
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.SET_RETURN_BTN]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      returnBtn: action.payload.btn
    });
  },
  [TYPES.SET_REGISTER_DT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      registerDt: action.payload.dt
    });
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);